<template>
  <!-- Configure "view" prop for QLayout -->
  <div class="layout">
    <div class="layout-drawer drawer-closed">
      <div class="sidebar" :style="environment === 'local'
      ? 'background-image: linear-gradient(0deg,#4e4e4e 0,#62656c);'
      : 'background-image: linear-gradient(to top, #37ecba 0%, #528dc3 100%);'">
        <div class="title">billing</div>
        <div class="logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 179.9">
            <path
              d="M9.9 166.8c-.3.2-.9.2-1.2 0l-7.5-5.1c-.3-.2-.6-.1-.6.3v4.8c0 .4.3.9.6 1.1l3.6 2c.4.2.4.5 0 .7l-3.6 2c-.4.2-.6.7-.6 1.1v5.1c0 .4.3.6.6.3l7.8-5.4c.3-.2.9-.2 1.2 0l8.7 6.1c.3.2.6.1.6-.3v-4.9c0-.4-.3-.9-.6-1.1l-4.7-2.9c-.3-.2-.3-.6 0-.7l4.7-2.7c.4-.2.6-.7.6-1.1v-5c0-.4-.3-.6-.6-.3l-9 6zM0 146.9v.3c0 3.4 1 5.9 3 7.6 2 1.7 4.3 2.6 7 2.6s5-.9 7-2.6 3-4.3 3-7.6v-.3c0-3.4-1-5.9-3-7.6-2-1.7-4.3-2.6-7-2.6s-5 .9-7 2.6c-2 1.7-3 4.3-3 7.6zm13.7-3.3c.8.7 1.3 1.5 1.6 2.4.1.2.1.4.1.6v1.2c0 .2-.1.4-.1.6-.3.8-.8 1.6-1.6 2.3-.8.7-2 1-3.6 1s-2.8-.3-3.6-1c-.8-.7-1.4-1.4-1.6-2.3-.1-.2-.1-.4-.1-.6v-.6-.6c0-.2.1-.4.1-.6.2-.9.8-1.6 1.6-2.4.8-.7 2-1.1 3.7-1.1 1.4 0 2.7.4 3.5 1.1zm-9-27.8c-1 .3-2 1-2.9 2-.9 1-1.3 3.2-1.3 4.6v7.5c0 .4.3.7.7.7h17.4c.4 0 .7-.3.7-.7v-4.1c0-.4-.3-.7-.7-.7H14c-.4 0-.7-.3-.7-.7v-1.9c0-2-.4-3.6-1.3-4.6-.9-1-1.9-1.7-2.9-2-.4-.1-.7-.2-1.1-.3-.4 0-.7-.1-1-.1-.3 0-.7 0-1 .1-.6 0-.9.1-1.3.2zm2.6 5.5c.2 0 .4.1.6.1.3.1.6.4.8.7.3.4.3 1 .3 1 0 .4.1 1 .1 1.4 0 .3-.3.6-.7.6h-3c-.4 0-.7-.3-.7-.7v-.5c0-.9.1-1.5.5-1.9.3-.4.7-.6 1-.7h.6c.2-.1.3-.1.5 0zM.6 50.4v4.1c0 .4.3.7.7.7h12.9c.4 0 .7.3.7.7v2.8c0 .4-.3.7-.7.7H1.3c-.4 0-.7.3-.7.7v4.1c0 .4.3.7.7.7h12.9c.4 0 .7.3.7.7v2.8c0 .4-.3.7-.7.7H1.3c-.4 0-.7.3-.7.7v4.1c0 .4.3.7.7.7h17.4c.4 0 .7-.3.7-.7V50.5c0-.4-.3-.7-.7-.7H1.3c-.4-.1-.7.2-.7.6zM0 33.1v.3c0 3.4 1 5.9 3 7.6s4.3 2.6 7 2.6 5-.9 7-2.6 3-4.3 3-7.6v-.3c0-3.4-1-5.9-3-7.6-2-1.7-4.3-2.6-7-2.6s-5 .9-7 2.6c-2 1.7-3 4.3-3 7.6zm13.7-3.3c.8.7 1.3 1.5 1.6 2.4.1.2.1.4.1.6V34c0 .2-.1.4-.1.6-.3.8-.8 1.6-1.6 2.3-.8.7-2 1-3.6 1s-2.8-.3-3.6-1c-.8-.7-1.4-1.4-1.6-2.3-.1-.2-.1-.4-.1-.6v-.6-.6c0-.2.1-.4.1-.6.2-.9.8-1.6 1.6-2.4.8-.7 2-1.1 3.7-1.1 1.4 0 2.7.4 3.5 1.1zM.6.8v15.7c0 .4.3.7.7.7h17.4c.4 0 .7-.3.7-.7v-4.7c0-.1-.3-.1-.7-.1H5.8c-.4 0-.7-.3-.7-.7V6.3c0-.4.3-.7.7-.7h12.9c.4 0 .7-.3.7-.7V.7c0-.4-.3-.7-.7-.7H1.3C.9 0 .6.4.6.8zm7.7 85.6H8c-4.4 0-8.1 3.7-8.1 8.1 0 3.2 1.9 6 4.6 7.3-.3.6-.4 1.2-.4 1.9 0 2 1.6 3.7 3.6 4.1.9 2.4 3.2 4.2 6 4.2 3.4 0 6.3-2.8 6.3-6.2V86.5c0-3.1-2.6-5.7-5.7-5.7-3.2 0-6 2.5-6 5.6z"/>
          </svg>
        </div>

        <div class="menu">
          <q-list no-border link inset-delimiter class="menu-list">
            <q-item to="/users">
              <q-item-side icon="supervisor_account"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Клиенты</q-tooltip>
            </q-item>
            <q-item to="/projects">
              <q-item-side icon="library_books"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Проекты</q-tooltip>
            </q-item>
            <q-item to="/tags">
              <q-item-side icon="local_offer"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Теги</q-tooltip>
            </q-item>
            <q-item to="/versions">
              <q-item-side icon="storage"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Версии</q-tooltip>
            </q-item>
            <q-item to="/bills">
              <q-item-side icon="local_atm"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Счета</q-tooltip>
            </q-item>
            <q-item to="/logs">
              <q-item-side icon="view_headline"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Логи</q-tooltip>
            </q-item>
            <q-item to="/service-providers" v-if="$auth.check('root') || $auth.check('manager')">
              <q-item-side icon="folder_shared"/>
              <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Реквизиты</q-tooltip>
            </q-item>
              <q-item to="/project-configs" v-if="$auth.check('root') || $auth.check('manager')">
                  <q-item-side icon="phonelink_setup"/>
                  <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Конфигурации проектов в облаке</q-tooltip>
              </q-item>
          </q-list>
        </div>
        <div class="userbar">
          <q-item :to="getProfileUrl()">
            <q-item-side icon="account_circle"/>
            <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">
              {{$auth.user().first_name}} {{$auth.user().last_name}}
            </q-tooltip>
            <q-item-main :label="`${$auth.user().first_name} ${$auth.user().last_name}`"/>
          </q-item>
          <q-item @click.native="logout" link class="logout">
            <q-item-side icon="exit_to_app" />
            <q-tooltip anchor="center right" self="center left" :offset="[5, 0]" :delay="500">Выйти</q-tooltip>
          </q-item>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div class="scroll-container">
        <router-view/>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    QLayout,
    QLayoutDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QListHeader,
    QItem,
    QItemSide,
    QItemSeparator,
    QItemMain,
    QItemTile,
    QTooltip
  } from 'quasar';

  export default {
    name: 'home',
    components: {
      QLayout,
      QLayoutDrawer,
      QPageContainer,
      QPage,
      QToolbar,
      QToolbarTitle,
      QBtn,
      QIcon,
      QList,
      QListHeader,
      QItem,
      QItemSide,
      QItemSeparator,
      QItemMain,
      QItemTile,
      QTooltip
    },
    data () {
      return {
        drawer: true,
        environment: 'production',
      };
    },
    beforeCreate () {
      this.$auth.fetch();
    },
    mounted() {
      if (process.env.hasOwnProperty('MIX_ENV')) {
        this.environment = process.env.MIX_ENV;
      }
    },
    methods: {
      logout () {
        this.$auth.logout({
          makeRequest: false,
          params: {}, // data: {} in axios
          success: function () {},
          error: function () {},
          redirect: '' +
              '/welcome'
        });
      },
      getProfileUrl () {
        return `/users/${this.$auth.user().id}`;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .layout {
    display: flex;
    width: 100%;
    min-height: 100vh;
  }

  .q-item-side {
    color: #fff;
    text-align: center;
  }

  .q-item-main {
    color: #fff;
  }

  .q-item.active, .q-item.router-link-active, .q-item:focus {
    background: rgba(255, 255, 255, 0.3);
  }

  .q-list-highlight > .q-item:hover, .q-item-highlight:hover, .q-list-link > .q-item:hover, .q-item-link:hover {
    background: rgba(255, 255, 255, 0.45);
  }

  .sidebar {
    position: absolute;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .title {
    padding: 14px 0;
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }

  .menu {
    flex: 1 1 auto;
  }

  .menu-list {
    padding: 0;
  }

  .logo {
    position: absolute;
    bottom: 122px;
    left: 22px;
    opacity: 0.35;
    /*flex: 0 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;

    svg {
        width: 36px;
        height: auto;
        fill: #fff;
    }*/
    svg {
      fill: #fff;
      width: 20px;
      height: auto;
    }
  }

  .userbar {
    position: relative;
    flex: 0 1 auto;
    margin: 10px 0;
  }

  .logout {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }

  .drawer-closed .logout {
    position: static;
  }

  .profile-link {
    color: inherit;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/MainView.vue